<template>
    <!-- 分包管理 -->
    <div class="join-ent-box">
        <div class="box-head">
            <el-page-header @back="goBack" :content="pageEnt"></el-page-header>
        </div>
        <div class="box-con">
            <el-form ref="form" :model="form" label-width="180px" :rules="rules">
                <h2 style="height: 5vh;line-height: 5vh;padding-left:160px;text-align: left;color:#5C69E3;">{{proEntName}}</h2>
                <el-form-item label="分包工程内容：">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="form.contents"></el-input>
                </el-form-item>
                <el-form-item label="合同总额：">
                    <el-input v-model="form.contractAmount"></el-input>
                </el-form-item>
                <el-form-item label="资质等级：">
                    <el-input v-model="form.levelQualification"></el-input>
                </el-form-item>
                <el-form-item label="安全生产许可证日期：">
                    <el-date-picker v-model="form.productionSafetyDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
                </el-form-item>
                <el-form-item label="分包楼号：">
                    <el-input v-model="form.subcontractBuilding"></el-input>
                </el-form-item>
                <el-form-item label="总分包合同：">
                    <div class="contract-photo" v-for="(item,index) in fileList" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:234}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="handleAvatarSuccess"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="工程款支付凭证：">
                    <div class="contract-photo" v-for="(item,index) in payList" :key="index">
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                    <el-upload
                    class="avatar-uploader"
                    v-bind:action="uploadUrl"
                    :headers="uploadHead"
                    :data={type:234}
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="fileSuccess"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="分包单位现场负责人：">
                    <el-input v-model="form.fieldSupervisor"></el-input>
                </el-form-item>
                <el-form-item label="分包单位总公司负责人：">
                    <el-input v-model="form.headCompany"></el-input>
                </el-form-item>
                <el-form-item label="联系方式：" prop="headCompanyPhone">
                   <el-input v-model="form.headCompanyPhone"></el-input>
                </el-form-item>
                <el-form-item label="分包单位总公司地址：">
                    <el-input v-model="form.companyAddress"></el-input>
                </el-form-item>
                <el-form-item label="联系方式：">
                    <el-input v-model="form.contactPhone"></el-input>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="form.note"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">提交</el-button>
                    <!-- <el-button @click="resetForm('form')">重置</el-button> -->
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port';
import util from '../../../untils/util'
export default {
    data(){
        //手机号验证
        var validatePhone = (rule, value, callback) => {
            if (value === '') {
            // callback(new Error('请输入手机号码！'));
            callback();
            } else if(!(/^1[3456789]\d{9}$/.test(value))){
            callback(new Error('手机号码格式错误！'));
            }else{
            callback();
            }
        };
        return{
            pageEnt:'',
            projectEntId:'',
            form:{
                id:'',
                contents:'',  //分包内容
                contractAmount:'', //合同金额
                levelQualification:'',
                productionSafetyDate:util.myTime.getCurTime(),  //安全生产许可证日期
                subcontractBuilding:'',   //分包楼号
                contractPhoto:'',  //合同图片
                paymentPhoto:'',   //工程款支付凭证
                fieldSupervisor:'',  //现场负责人
                headCompany:'',   //公司负责人
                headCompanyPhone:'',  //公司负责人手机号
                companyAddress:'',  //公司地址
                contactPhone:'',  //联系电话
                note:'',  //备注
                createBy:'',
                projectEntId:'',
                projectId:''
            },
            rules:{
                contractAmount: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { type: 'number', message: '年龄必须为数字值', trigger: 'blur' }
                ],
                headCompanyPhone:[{ validator: validatePhone, trigger: 'blur' }],
            },
            fileList:[],
            // uploadUrl:base.url+"/upload/uploadPhotosAndThumbnail",//上传地址
            uploadUrl:base.url + '/upload/uploadPhoto', //上传地址
            uploadHead:{  //上传接口header
                accessToken:util.session.get('token')
            },
            payList:[],
            proEntName:'',//参建单位名称
            // imageUrl: false
        }
    },
    mounted(){
        var params = this.$route.params
        this.projectEntId = params.id
        this.form.projectEntId=this.projectEntId
        this.form.projectId=util.session.get('groupId')
        this.getData()
        this.getInfo()
    },
    methods:{
        //获取参建信息
        getInfo(){
            var that = this
            myHttp.selectProjectEnt({
                id:this.projectEntId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.proEntName = resp.data.data.ProjectEnt.entName||''
                    that.pageEnt = resp.data.data.ProjectEnt.projectName||''
                }
            })
        },
        //获取数据
        getData(){
            var that = this
            myHttp.selectProjectSubcontractOne({
                projectEntId:this.projectEntId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.ProjectSubcontract
                    if(data){
                        that.form.id = data.id
                        that.form.projectEntId=data.projectEntId
                        that.form.projectId=data.projectId
                        that.form.contents = data.contents  //分包内容
                        that.form.contractAmount=data.contractAmount //合同金额
                        that.form.levelQualification=data.levelQualification
                        that.form.productionSafetyDate=data.productionSafetyDate  //安全生产许可证日期
                        that.form.subcontractBuilding=data.subcontractBuilding   //分包楼号
                        that.form.contractPhoto=data.contractPhoto  //合同图片
                        that.form.paymentPhoto=data.paymentPhoto   //工程款支付凭证
                        that.form.fieldSupervisor=data.fieldSupervisor  //现场负责人
                        that.form.headCompany=data.headCompany   //公司负责人
                        that.form.headCompanyPhone=data.headCompanyPhone  //公司负责人手机号
                        that.form.companyAddress=data.companyAddress  //公司地址
                        that.form.contactPhone=data.contactPhone  //联系电话
                        that.form.note=data.note  //备注
                        that.fileList = []
                        if(data.contractPhoto && ''!=data.contractPhoto){
                            var lis = data.contractPhoto.split(',')
                            for(var i=0;i<lis.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis[i]
                                obj.showUrl = base.httpCtx + lis[i]
                                obj.srcList = [base.httpCtx + lis[i]]
                                that.fileList.push(obj)
                            }
                        }
                        that.payList = []
                        if(data.paymentPhoto && ''!=data.paymentPhoto){
                            var lis1 = data.paymentPhoto.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.payList.push(obj)
                            }
                        }
                    }
                }
            })
        },

        //上传1
        handleAvatarSuccess(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.fileList.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //上传2
        fileSuccess(res, file){
            if(res.code == 200){
                var obj = {}
                obj.uid = file.uid
                obj.url = res.data.saveUrls
                obj.showUrl = base.httpCtx + res.data.saveUrls
                obj.srcList = [base.httpCtx + res.data.saveUrls]
                this.payList.push(obj)
            }else{
                this.$message.error(resp.data.msg)
            }
        },
        //提交
        submitForm(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.form.contractPhoto = ''
                    this.form.paymentPhoto = ''
                    for(var i=0;i<this.fileList.length;i++){
                        this.form.contractPhoto = this.form.contractPhoto==''?this.fileList[i].url:this.form.contractPhoto+','+this.fileList[i].url
                    }
                    for(var j=0;j<this.payList.length;j++){
                        this.form.paymentPhoto = this.form.paymentPhoto==''?this.payList[j].url:this.form.paymentPhoto+','+this.payList[j].url
                    }
                    var that = this
                    if(this.form.id==''){
                        this.form.createBy = util.session.get('user').id
                        myHttp.postProjectSubcontract(this.form).then(function(resp){
                            if (resp.data.code == '200') {
                                that.$message.success('提交成功')
                                // that.$router.push({ path: '/tqm' })
                            } else {
                                that.$message.error(resp.data.msg)
                            }
                        })
                    }else{
                        this.form.updateBy = util.session.get('user').id
                        myHttp.updateProjectSubcontract(this.form).then(function(resp){
                            if (resp.data.code == '200') {
                                that.$message.success('修改成功')
                            } else {
                                that.$message.error(resp.data.msg)
                            }
                        })
                    }
                } else {
                    return false;
                }
            });
        },
        // handleRemove(file) {
        //     console.log(file);
        // },
        // handlePictureCardPreview(file) {
        //     this.dialogImageUrl = file.url;
        //     this.dialogVisible = true;
        // },
        // handleDownload(file) {
        //     console.log(file);
        // },
        //返回
        goBack(){
            this.$router.go(-1)
        },
    }
}
</script>

<style scoped>
    .join-ent-box{
        width: 100%;
        height: 100%;
        position: relative;
        /* padding: 1vh 5vw; */
        background: #fff;
    }
    .box-head{
        width: 100%;
        height: 5vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        border-bottom: 2px solid #048ff9;
        padding: 0 2vw;
    }
    .box-con{
        width: 100%;
        height: calc( 100% - 5vh );
        position: relative;
        padding: 1vh 5vw;
        overflow: auto;
    }
    .contract-photo{
        width: 116px;
        height: 116px;
        position: relative;
        padding:0 16px 16px 0;
    }
</style>

<style>
    .join-ent-box .el-form-item__content{
        text-align: left;
        display: flex;
        flex-wrap: wrap;
    }
    .join-ent-box .el-textarea__inner{
        max-width: 300px;
    }
    .join-ent-box .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .join-ent-box .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .join-ent-box .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }
    .join-ent-box .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }
</style>